/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import ObjectModel from 'cio/models/object';
import CustomerModel from 'cio/models/customer';
import { pluralize } from 'ember-inflector';
import ObjectTypeModel from 'cio/models/object-type';
import AttributesProxy from 'cio/app-models/customer/attributes-proxy';

interface Args {
  selectedPeople: CustomerModel[];
  selectedObjects: ObjectModel[];
  object?: ObjectModel;
  customer?: CustomerModel;
  objectType: ObjectTypeModel;
  attributesProxy: AttributesProxy;
}

export default class Review extends Component<Args> {
  get objectType() {
    return this.args.objectType ?? this.args.selectedObjects.firstObject?.belongsTo('objectType').value();
  }

  get targetCustomers() {
    let { selectedPeople, customer } = this.args;

    if (selectedPeople.length === 1) {
      return selectedPeople[0].displayName;
    }

    if (customer == null) {
      return pluralize(selectedPeople.length, 'person');
    }

    return customer.displayName;
  }

  get targetObjects() {
    let { selectedObjects, object } = this.args;

    if (selectedObjects.length === 1) {
      return selectedObjects[0].displayName;
    }

    if (object == null) {
      return pluralize(selectedObjects.length, this.objectType.singularName);
    }

    return object.displayName;
  }

  get attributesCount() {
    let { attrs } = this.args.attributesProxy.getModelAttributes();

    return Object.keys(attrs).length;
  }
}
